import { render, staticRenderFns } from "./AnnotationTagContainer.vue?vue&type=template&id=23ba75c4&"
import script from "./AnnotationTagContainer.vue?vue&type=script&lang=js&"
export * from "./AnnotationTagContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ba75c4')) {
      api.createRecord('23ba75c4', component.options)
    } else {
      api.reload('23ba75c4', component.options)
    }
    module.hot.accept("./AnnotationTagContainer.vue?vue&type=template&id=23ba75c4&", function () {
      api.rerender('23ba75c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/AnnotationTagContainer.vue"
export default component.exports